import React from 'react';

import {IconSizeType} from 'common/constants';
import {ButtonReact} from 'common/components/button';
import {SvgIconReact} from 'common/components/svg-icon';
import {getProfilePath} from 'common/report/util/profile/utils';
import {withStyles} from 'common/util/react';
import {react2panel} from 'common/util/react2panel';
import {pluralize} from 'common/util/string';
import {formatDuration} from 'common/util/date';

import {TrackedUserIconReact} from '../tracked-user-icon';
import {RecordingMetadata} from './types';
import styles from './index.module.styl';
import css from './index.module.styl?inline';
import {getReplayEventCount, getSearchHighlightPieces} from './util';

type ReplayPlaylistRowProps = {
  sortedReplays: RecordingMetadata[];
  currentRecordingIdx: number;
  hasBeenPlayed: boolean;
  replay: RecordingMetadata;
  displayName: string;
  displayTime: string;
  searchFilter: string;
  isExpanded: boolean;
  onToggleExpand: (replayId: string) => void;
};

function replayPlaylistRow(props: ReplayPlaylistRowProps) {
  function maybeShowSearchHighlight(inputText: string) {
    const pieces = getSearchHighlightPieces(inputText, props.searchFilter);

    return (
      <>
        {pieces.map((piece) => {
          return <span className={piece.highlight ? styles.replaysTextHighlight : ``}>{piece.text}</span>;
        })}
      </>
    );
  }

  const getFormattedDuration = (duration: number) => {
    if (!duration) {
      return `Unknown Duration`;
    }

    const formattedDuration = formatDuration(duration, 0);

    return `${formattedDuration.value} ${pluralize(formattedDuration.unit, formattedDuration.value)}`;
  };

  const eventCount = getReplayEventCount(props.replay);

  return (
    <div
      className={`${styles.replaysListItem} ${
        props.replay.replayId === props.sortedReplays[props.currentRecordingIdx].replayId
          ? styles.replaysListItemSelected
          : ``
      }`}
    >
      <div className={styles.replaysListItemInfo}>
        <a href={getProfilePath(props.replay.distinctId, null)} target='_blank'>
          <TrackedUserIconReact
            className={styles.replaysListItemUserIcon}
            distinctId={props.replay.distinctId}
            imgSrc={props.replay.avatarUrl}
            email={props.replay.email}
            size={IconSizeType.Small}
          />
        </a>
        <div className={styles.replaysListItemText}>
          <div className={styles.replaysListItemTextTitle}>{maybeShowSearchHighlight(props.displayName)}</div>
          <div className={styles.replaysListItemTextSubtitle}>
            {maybeShowSearchHighlight(props.displayTime)}
            {` `}• {eventCount} {pluralize(`Event`, eventCount)} •{` `}
            {getFormattedDuration(props.replay.duration)}
          </div>
        </div>
      </div>
      <div className={styles.replaysListItemIndicators}>
        {props.hasBeenPlayed && <SvgIconReact className={styles.replaysListItemPlayedIcon} icon={`circle-checkmark`} />}
        <ButtonReact
          icon={props.isExpanded ? `caret-up` : `caret-down`}
          onClick={(ev) => {
            props.onToggleExpand(props.replay.replayId);
            ev.stopPropagation();
          }}
        />
      </div>
    </div>
  );
}

const ReplayPlaylistRowStyled = withStyles(replayPlaylistRow, css);
export const ReplayPlaylistRowEl = react2panel(`mp-replay-playlist-row`, ReplayPlaylistRowStyled);
